import React from 'react';
import { Parallax } from "react-parallax";
import { format } from 'date-fns';
import { FaFacebookF, FaHistory, FaWhatsapp } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { useNavigate, useLocation } from 'react-router-dom';

const NoticiaTopo = ({ foto, titulo, previa, dataPublicacao }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const paginaAtual =
        typeof window !== 'undefined' ? window.location.href : '';

    // Compartilhamento
    const compartilharFacebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        paginaAtual
    )}`;

    const compartilharWhatsApp = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `${titulo} - ${paginaAtual}`
    )}`;

    // Voltar inteligente
    const handleBack = () => {
        if (location.state?.from) {
            navigate(location.state.from);
        } else {
            navigate('/noticias');
        }
    };

    return (
        <>
            <Helmet>
                <title>{titulo ? `${titulo} | Fetron` : 'Fetron - Notícias'}</title>
                <meta property="og:title" content={titulo || 'Fetron'} />
                <meta property="og:description" content={previa || ''} />
                <meta property="og:image" content={foto || ''} />
                <meta property="og:url" content={paginaAtual} />
                <meta property="og:type" content="article" />
                <meta property="og:site_name" content="Fetron" />
            </Helmet>

            <Parallax className="p-0" bgImage={foto} strength={300}>
                <div className="spacer-150"></div>
            </Parallax>

            <div className="container position-relative">
                <h2 className="wow fadeInUp" data-wow-delay=".2s">
                    {titulo}
                </h2>

                <div className="spacer-20"></div>

                <h3 className="wow fadeInUp" data-wow-delay=".4s">
                    {previa}
                </h3>

                <div className="spacer-30"></div>

                {/* BOTÕES */}
                <div className="wow fadeInUp d-flex gap-3 flex-wrap" data-wow-delay=".5s">
                    <a
                        href={compartilharFacebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary d-flex align-items-center gap-2"
                    >
                        <FaFacebookF size={18} />
                        Facebook
                    </a>

                    <a
                        href={compartilharWhatsApp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-success d-flex align-items-center gap-2"
                    >
                        <FaWhatsapp size={18} />
                        WhatsApp
                    </a>

                    <button
                        onClick={handleBack}
                        className="btn btn-dark d-flex align-items-center gap-2"
                    >
                        <FaHistory size={18} />
                        Voltar
                    </button>
                </div>

                <div className="spacer-30"></div>

                <p className="wow fadeInUp">
                    {dataPublicacao &&
                    !isNaN(new Date(dataPublicacao).getTime())
                        ? `Data de publicação: ${format(
                              new Date(dataPublicacao),
                              'dd/MM/yyyy'
                          )}`
                        : ''}
                </p>
            </div>
        </>
    );
};

export default NoticiaTopo;
